import React, { useState, useEffect } from "react";
import {
  Button,
  Input,
  Row,
  Col,
  InputGroup,
  ButtonGroup,
  Label,
  FormGroup,
  Modal,
} from "reactstrap";
import { Triangle } from "react-loader-spinner";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

// import OrganizationService from "../../../../Services/QRCodeServices/OrganizationManagement/OrganizationService";
import DetailOrgDbModal from "./DetailOrgDbModal";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import CustomDataTable from "../../Components/CustomTable/CustomTable";
import OrganizationService from "../../services/OrderingServices/OrganizationService";
import TenantForm from "./component/TenantForm";
import DeleteModal from "../../Components/Common/DeleteModal";

// import "./SwitchModal.css";
const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const TenantOrganization = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isFormModalOpen, setIsFormModalOpen] = useState(false);
  const [data, setData] = useState([]); // Initialize as empty array
  const [detailData, setDetailData] = useState({});
  const [selectedItem, setSelectedItem] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);

  const toggleFormModal = (item = null) => {
    setIsFormModalOpen(!isFormModalOpen);
    setSelectedItem(item);
  };

  const toggleDeleteModal = () => setDeleteModal(!deleteModal);

  // Fetch organizations with validation
  const fetchOrganizations = async () => {
    setLoading(true);
    try {
      const response = await OrganizationService.GetOrgDatabaseList();
      console.log("🚀 ~ fetchOrganizations ~ response:", response);
      // Ensure response is an array; fallback to empty array if not
      setData(response?.data);
    } catch (error) {
      console.error("Error fetching organizations:", error);
      setData([]); // Ensure data is always an array
    } finally {
      setLoading(false);
    }
  };

  // Fetch organization details
  const fetchDetail = async () => {
    setLoading(true);
    try {
      const response = await OrganizationService.GetOrgDatabaseDetail(
        selectedItem?.id
      );
      console.log("🚀 ~ fetchDetail ~ response:", response);
      if (response && response.data) {
        setDetailData(response.data);
        setIsFormModalOpen(true);
      } else {
        toast.error("Invalid organization data");
      }
    } catch (error) {
      toast.error("Error fetching organization details");
      console.error("Error fetching organization details:", error);
      setDetailData({});
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrganizations();
  }, []);
  useEffect(() => {
    if (selectedItem?.id) {
      fetchDetail();
    }
  }, [selectedItem?.id]);
  const handleDeleteClick = (id) => {
    setSelectedItem(id);
    toggleDeleteModal();
  };

  const handleDelete = async () => {
    if (selectedItem) {
      try {
        await OrganizationService.delete(selectedItem);
        setData((prevList) =>
          prevList.filter((pkg) => pkg.id !== selectedItem)
        );
        toast.success("Selected organization deleted successfully");
      } catch (error) {
        toast.error("Failed to delete the record");
        console.error("Error deleting organization:", error);
      } finally {
        toggleDeleteModal();
        setSelectedItem(null);
      }
    }
  };

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "75px",
    },
    {
      name: "Org Name",
      selector: (row) => (
        <Link to={`/tenant/detail/${row.id}`}>{row?.organizationName}</Link>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Server",
      selector: (row) => row?.serverName || "N/A",
      sortable: true,
      wrap: true,
    },
    {
      name: "DB Name",
      selector: (row) => row?.databaseName || "N/A",
      sortable: true,
      wrap: true,
    },
    {
      name: "Email",
      selector: (row) => row?.adminEmail || "N/A",
      sortable: true,
      wrap: true,
    },
    {
      name: "No of Users",
      selector: (row) => row?.numberOfUsers || "N/A",
      sortable: true,
      wrap: true,
      center:true
    },
    {
      name: "Action",
      cell: (row) => (
        <ButtonGroup className="gap-2">
          <Button
            color="warning"
            className="rounded-circle btn-sm d-flex align-items-center justify-content-center"
            onClick={() => toggleFormModal(row)}
          >
            <i className="bx bx-edit"></i>
          </Button>
          <Button
            color="danger"
            className="rounded-circle btn-sm d-flex align-items-center justify-content-center"
            style={{ width: "30px", height: "30px" }}
            onClick={() => handleDeleteClick(row.id)}
          >
            <i className="bx bx-trash"></i>
          </Button>
        </ButtonGroup>
      ),
      center: true,
    },
  ];
  const [filterText, setFilterText] = useState("");

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };
  const filteredData = data?.filter((pkg) => {
    // console.log("🚀 ~ filteredPackages ~ pkg:", pkg);

    // Combine name, surname, email, and phone number into a single search context, handling undefined fields
    const searchContext = `${pkg?.organizationName || ""} ${
      pkg?.databaseName || ""
    } ${pkg?.email || ""}`.toLowerCase();

    // Check if the filterText is included in any of the search context
    const matchesFilter = searchContext.includes(filterText.toLowerCase());

    return matchesFilter;
  });



  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Tenant List" pageTitle="Tenant Management" />
      </div>

      <Row>
        <Col md={8} xs={12} className="mb-2">
          <InputGroup>
            <Input
              placeholder="Search by org name, email and database name"
              value={filterText}
              onChange={handleFilterChange}
            />
          </InputGroup>
        </Col>
        <Col
          md={4}
          xs={12}
          className="d-flex justify-content-end align-items-end mb-2"
        >
          <button
            className="btn btn-success"
            onClick={() => toggleFormModal(null)}
          >
            + Create
          </button>
        </Col>
      </Row>

      <CustomDataTable
        responsive
        striped
        pagination
        fixedHeader
        persistTableHead
        progressPending={loading}
        customStyles={customStyles}
        progressComponent={
          <div className="my-3">
            <Triangle
              visible={true}
              height="80"
              width="80"
              color="#5B71B9"
              ariaLabel="triangle-loading"
            />
            <h5 className="mt-1">Loading...</h5>
          </div>
        }
        columns={columns}
        data={filteredData} // Ensure data is always an array
      />

      <TenantForm
        isOpen={isFormModalOpen}
        toggle={toggleFormModal}
        selectedItem={selectedItem}
        fetchOrganizations={fetchOrganizations}
        detailData={detailData}
      />

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={toggleDeleteModal}
        selectedItem={selectedItem}
      />
    </div>
  );
};

export default TenantOrganization;
